<script>
export default {
    name: "ThumbsProducts",
    data() {
        return {
            mobileThumbWidth: 160,
            desktopThumbWidth: 320,
            productThumbPath: 'thumbs/products',
            productOriginPath: 'images/products'
        }
    },
    methods: {
        getImageThumbSrc(images) {
            if (!images.length) {
                return '/images/default-product.png';
            }

            return this.getProductThumb(images[0]);
        },
        getProductThumb(image, width) {
            let thumbWidth;

            if(width) {
                thumbWidth = width;
            } else {
                thumbWidth = window.outerWidth > 1024 ? this.desktopThumbWidth : this.mobileThumbWidth;
            }

            const basePath = `${this.productThumbPath}/${thumbWidth}`;

            return image.replace(this.productOriginPath, basePath);
        }
    },
}
</script>

<style scoped>

</style>
